import { withErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
    Headline,
    HowToFixItHTML,
    ReloadPageButton,
    WhatHappenedHTML,
    WhyIsThisAProblemHTML
} from 'autogen/translation-keys/trans-website-contentful-recursionpage';
import AlertUserMessage from 'components/AlertUserMessage';
import { Button } from 'components/Button';
import { Typography } from 'components/generic/typography';
import Layout from 'components/Layout';
import format from 'helpers/translations';

const StyledButton = styled(Button)`
    width: fit-content;
`;

function reloadPage() {
    window.location.reload();
}

function RecursionPreviewPage() {
    const { t } = useTranslation();

    return (
        <Layout.Page>
            <Layout.Section>
                <AlertUserMessage
                    model={{
                        headline: t(Headline),
                        isRouteMessage: false,
                        messageType: 'Alert_Danger',
                        renderValidationSummary: false,
                        showAsToast: false
                    }}
                />
                <Typography.Body as="div">{format(t(WhatHappenedHTML))}</Typography.Body>
                <Typography.Body as="div">{format(t(WhyIsThisAProblemHTML))}</Typography.Body>
                <Typography.Body as="div">{format(t(HowToFixItHTML))}</Typography.Body>

                <StyledButton type="button" onClick={reloadPage}>
                    {t(ReloadPageButton)}
                </StyledButton>
            </Layout.Section>
        </Layout.Page>
    );
}

export default withErrorBoundary(RecursionPreviewPage, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
